exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./fonts/Montserrat-Regular.ttf"));
var ___CSS_LOADER_URL___1___ = urlEscape(require("./fonts/Raleway-Regular.ttf"));

// Module
exports.push([module.id, "@font-face {\n    font-family: Montserrat;\n    src: url(" + ___CSS_LOADER_URL___0___ + ") format('truetype');\n}\n@font-face {\n    font-family: Raleway;\n    src: url(" + ___CSS_LOADER_URL___1___ + ") format('truetype');\n}", ""]);

